import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const DrawerStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      width: "auto",
    },
  })
);
